import requestDataCache from './requestDataCache';
import requestData from './requestData';

export default function forceRequestData (request, ...requestArgs) {
  return dispatch => {
    let requestKey = request.keyFor(...requestArgs);
    let [subject, subscription] = requestDataCache.get(requestKey);

    subscription.dispose();
    requestDataCache.set(requestKey, [subject, null]);
    dispatch(requestData(request, ...requestArgs));
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/forceRequestData.js